import { useStaticQuery, graphql } from "gatsby";

const useListMap = () => {
  const data = useStaticQuery(graphql`
    {
      allTokyoMapsListMap {
        nodes {
          order
          orderByTitle
          category
          title
          description
          lat
          lng
          image1
          image2
          bussiness
          businessCategory
          color
        }
      }
    }
  `);
  return data;
};

export default useListMap;
